module.exports = __webpack_public_path__ + "img/carpentry.65c981ca.svg";